import _get from "lodash/get";
import _includes from "lodash/includes";
import { searchProviders } from "../../actions";
import track from "./track";
import { fireRequestErrorEvent } from "./utils";
var SUCCESS = 'success';
var FAIL = 'fail';

var shouldTrackRoles = function shouldTrackRoles(actionName) {
  var actions = ['requestidentity', 'signin', 'register', 'authenticateWithGoogle', 'authenticateWithApple', 'setSecurityQuestion'];
  return _includes(actions, actionName);
};

var getError = function getError(resp) {
  var error = 'Error';

  try {
    error = JSON.stringify(_get(resp, 'data.error') || _get(resp, 'error'));
  } catch (err) {
    if (_includes(['development', 'staging'], process.env.NODE_ENV)) {
      // eslint-disable-next-line no-console
      console.warn("JSON.stringify error in metrics request getError: ".concat(err));
    }
  }

  return error;
};

export default (function (state, action) {
  var payload = action.payload,
      _action$meta = action.meta,
      meta = _action$meta === void 0 ? {} : _action$meta;
  var actionName = meta.actionName,
      asyncType = meta.asyncType,
      resp = meta.resp,
      profileType = meta.profileType;

  var trackingState = _get(state, 'identity.tracking', null); // only handle async actions from the async middleware


  if (!_includes([SUCCESS, FAIL], asyncType)) return;
  var data = {
    status_code: _get(resp, 'resp.statusCode')
  };

  if (shouldTrackRoles(actionName)) {
    data.roles = _get(state, 'identity.current.roles', 'No roles');
  }

  if (actionName === searchProviders.NAME && asyncType === SUCCESS) {
    data.query = meta.query;
    data.search_hit = _get(payload, 'provider', []).length > 0;
  }

  if (profileType) {
    data.updatingProfileType = profileType;
  } // if the auto_registered flag is set on the authenticateWithGoogle response,
  // a new user was registered during the call to identity


  if (resp && actionName === 'authenticateWithGoogle') {
    data.googleAuthType = _get(resp, 'auto_registered') ? 'register' : 'signin';
    data.usingExistingToken = meta.usingExistingToken;
  }

  if (asyncType === FAIL) {
    data.error = getError(resp);
    fireRequestErrorEvent(action);
  }

  track("request:".concat(actionName, ":").concat(asyncType), trackingState, data);
});